// Time on Moksy earns — for ACTIVE minutes (earning plan trigger
// time_active). Once a minute, if the tab is visible and the person did
// something in it (pointer, key, scroll, touch), one heartbeat goes to
// progression, which keys the minute so a second heartbeat cannot pay
// twice and caps the day. An open tab nobody touches sends nothing.
import { useEffect, useRef } from 'react';
import ProgressionAPI from '../api/progression';

const EVENTS = ['pointerdown', 'keydown', 'scroll', 'touchstart'];

export default function useActiveMinutes({ enabled = true, intervalMs = 60_000 } = {}) {
  const interactions = useRef(0);
  useEffect(() => {
    if (!enabled) return undefined;
    const bump = () => { interactions.current += 1; };
    for (const e of EVENTS) window.addEventListener(e, bump, { passive: true });
    const tick = async () => {
      const n = interactions.current;
      interactions.current = 0;
      if (n <= 0 || document.visibilityState !== 'visible') return;
      try { await ProgressionAPI.activeMinute(n); } catch (_) { /* a missed minute is a missed minute; nothing to retry */ }
    };
    const timer = setInterval(tick, intervalMs);
    return () => { clearInterval(timer); for (const e of EVENTS) window.removeEventListener(e, bump); };
  }, [enabled, intervalMs]);
}
